module.exports = __webpack_public_path__ + "media/images/kds/check-be6e54fbaa915c4956f7c8647e5eeebb.svg";